import React from 'react'
import './HorizonBar.css'

function HorizonBar({text}) {
  return (
    <h1 className='horizon'>{text}</h1>
  )
}

export default HorizonBar